import {metadataService} from '../../application'
import {METADATA_FETCH, METADATA_FETCH_FAILED, METADATA_FETCH_SUCCESS} from "../mutations/available";
import {getMetadataSection} from "../getters/metadata";
import {RequestState} from "../../requestState";


export async function metadataGetIfRequired({state, commit, dispatch}, {table, id}) {
  const section = getMetadataSection(state)(table, id);

  if (section.requestState === RequestState.Success) {
    return section.response
  }

  return dispatch('metadataGet', {table, id})
}

export async function metadataGet({commit, dispatch}, {table, id}) {
  commit(METADATA_FETCH, {table, id});

  return metadataService
    .getMetadata({table, id})
    .then(response => {
      commit(METADATA_FETCH_SUCCESS, {table, id, response});
      return response
    })
    .catch(e => {
      commit(METADATA_FETCH_FAILED, {table, id, errorResponse: e});
      throw e
    })
}

export async function metadataUpdate({commit, dispatch}, {table, id, ...rest}) {
  return metadataService
    .updateMetadata({table, id, ...rest})
    .then(response => {
      commit(METADATA_FETCH_SUCCESS, {table, id, response});
    })
}



// WEBPACK FOOTER //
// ./src/store/actions/metadata.js